import { ROUTES } from '@/config/routes'
import axios, { AxiosError, HttpStatusCode } from 'axios'
import { saveSessionExpiredNotice } from '@/features/auth/utils/session-expired-notice'

function createApi() {
  const headers: Record<string, string> = {}

  const authorization = localStorage.getItem('auth')
  if (authorization) {
    const token = JSON.parse(authorization).token
    headers['Authorization'] = `Bearer ${token}`
  }

  const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    headers
  })

  api.interceptors.request.use(
    config => {
      const auth = localStorage.getItem('auth')
      if (auth) {
        const token = JSON.parse(auth).token
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    error => Promise.reject(error)
  )

  api.interceptors.response.use(
    response => response,
    error => {
      console.error('API Response error:', error)

      if (error instanceof AxiosError && error.response?.status === HttpStatusCode.Unauthorized) {
        const requestUrl = error.config?.url ?? ''
        const hadAuthenticatedUser = Boolean(localStorage.getItem('auth'))
        const isSignInRequest =
          requestUrl.endsWith('/auth/login') ||
          requestUrl.includes('/auth/login?') ||
          requestUrl.endsWith('/auth/login-client') ||
          requestUrl.includes('/auth/login-client?')

        // Não tratar erro de credencial de login como sessão expirada.
        if (isSignInRequest) {
          return Promise.reject(error)
        }

        // Só trata como sessão expirada quando havia sessão autenticada.
        if (!hadAuthenticatedUser) {
          return Promise.reject(error)
        }

        // para todas as outras chamadas 401 (usuário, token expirado...)
        saveSessionExpiredNotice()
        localStorage.clear()
        window.location.href = ROUTES.SIGNIN.path
      }

      return Promise.reject(error)
    }
  )
  return api
}

export const publicApi = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL
})

const api = createApi()
export default api
